/**
 * TutorLivesListScreen — la semaine du masteur, « Mes prochains lives » (`tutor/lives`), ouverte par
 * « Toute la semaine » de « Ma journée ». Un fil : les lectures, le view-model, les gestes, la page.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorLivesListPage } from "../../../../../../design-system/tutor"
import { tutorLivesListViewModel } from "../../../../view-models/tutor/Lives/tutorLivesListViewModel"
import { useTutorLivesListData } from "./useTutorLivesListData"
import { useTutorLivesListState } from "./useTutorLivesListState"

export function TutorLivesListScreen() {
    const vm = useSelector(tutorLivesListViewModel)
    const { refresh, refreshing, notice, dismissNotice } = useTutorLivesListData()
    const gestures = useTutorLivesListState()

    return (
        <TutorLivesListPage
            groups={vm.groups}
            loading={vm.loading}
            refreshing={refreshing}
            onRefresh={refresh}
            notice={notice}
            onDismissNotice={dismissNotice}
            {...gestures}
            testID="tutor-lives-list"
        />
    )
}
